import React from 'react';
import { Link } from 'react-router-dom';
import emptyCartImg from '../assets/img/empty-cart.png';
import '../scss/components/empty_cart.scss'

const EmptyCart = () => {
  return (
    <>
      <div className="cart-wrapper">
        <div className="empty-cart">
       <div >
       <h2 className='empty__cart_title'>
          Корзина пустая <icon>😕</icon>
        </h2>
        <p className="text">
          Вероятней всего, вы не заказывали ещё продукты.
          <br />
          Для того, чтобы заказать продукты, перейди на главную страницу.
        </p>
       </div>
       <div className="button-block">
       <img src={emptyCartImg} className="empty-cart-img" alt="Empty cart" />
        <Link to="/" className="button button--black">
          <span className='button-back'>Вернуться назад</span>
        </Link>
       </div>
      </div>
        </div>
        
    </>
  );
};

export default EmptyCart;
